import { useNavigate } from 'react-router-dom';
import { TASK_GROUP_CONFIG_TYPE, TASK_KIND, type TaskKind, type TaskListItem } from '@fdh/shared';
import { taskGroupApi } from '../lib/api';

export const useEmployerEditTaskNavigation = () => {
  const navigate = useNavigate();

  const handleEditTaskClick = (task: TaskListItem) => {
    if (task.taskKind === TASK_KIND.INVENTORY) {
      navigate(`/tasks/${task.id}/edit/inventory`);
      return;
    }
    if (task.taskKind === TASK_KIND.PICKUP_DROPOFF || task.taskKind === TASK_KIND.MEDICATION_REMINDER) {
      void (async () => {
        const res = await taskGroupApi.resolveFromTask(task.id);
        if (res.success && res.data?.groupId) {
          const path =
            task.taskKind === TASK_KIND.PICKUP_DROPOFF
              ? `/tasks/groups/${res.data.groupId}/edit/pickup-dropoff`
              : `/tasks/groups/${res.data.groupId}/edit/medication-reminder`;
          navigate(path);
        }
      })();
      return;
    }
    navigate(`/tasks/${task.id}/edit`);
  };

  const handleEditTaskInstanceTemplate = (taskId: string, taskKind: TaskKind) => {
    if (taskKind === TASK_KIND.INVENTORY) {
      navigate(`/tasks/${taskId}/edit/inventory`);
      return;
    }
    if (taskKind === TASK_KIND.PICKUP_DROPOFF || taskKind === TASK_KIND.MEDICATION_REMINDER) {
      void (async () => {
        const res = await taskGroupApi.resolveFromTask(taskId);
        if (res.success && res.data?.groupId) {
          const path =
            taskKind === TASK_KIND.PICKUP_DROPOFF
              ? `/tasks/groups/${res.data.groupId}/edit/pickup-dropoff`
              : `/tasks/groups/${res.data.groupId}/edit/medication-reminder`;
          navigate(path);
        }
      })();
      return;
    }
    navigate(`/tasks/${taskId}/edit`);
  };

  const handleEditGroupClick = (groupId: string, configType: string) => {
    const path =
      configType === TASK_GROUP_CONFIG_TYPE.PICKUP_DROPOFF
        ? `/tasks/groups/${groupId}/edit/pickup-dropoff`
        : `/tasks/groups/${groupId}/edit/medication-reminder`;
    navigate(path);
  };

  return { handleEditTaskClick, handleEditTaskInstanceTemplate, handleEditGroupClick };
};
